/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

/*
  Class Description

  This class is the next satellite panel container wrapper.

  - It has a top-level styled component that serves as the root for applying styles to child elements.
  - It has a context provider that is provides the Terminal Details Object to the child components

 */

import React from 'react';
import styled from 'styled-components';
import NextSatellitePanelContainer from './NextSatellitePanelContainer';
import { TerminalDetails } from '../../../../shared/entities/terminal';
import StyledProps from '../../../common/theme/AppThemeInterface';
import { requireFeatureFlag, FEATURE_FLAGS } from '../../../../utils/FeatureFlagUtils';

export const TerminalDetailsContext = React.createContext({} as TerminalDetails);

export interface NextSatellitePanelContainerWrapperProps {
  terminalDetails: TerminalDetails;
}

export interface StyledNextSatellitePanelContainerWrapperProps {
  terminalDetails: TerminalDetails;
}

export interface NextSatellitePanelContainerWrapperState {}

const StyledNextSatellitePanelContainerWrapper = styled.div`
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: #465967;
  .next__satellite__container {
    height: 118px;
    width: 100%
    position: relative;
    .data_wrapper {
      top: 15px;
      left: 20px;
      width: 88.88%;
      height: 86px;
      position: absolute;
    }
    .icon {
      height: 18px;
      margin-right: 6px;
    }
    .header {
      height: 15px;
      font-size: 16px;
      font-weight: normal;
      height: 20px;
      letter-spacing: 0px;
      line-height: 20px;
      position: absolute;
      display: flex;
      align-items: center;
    }
    .background__line {
      height: 1px;
      width: 100%;
      top: 29px;
      background-color: #465967;
      position: absolute;
    }
    .label {
      top: 44px;
      position: absolute;
      color: white;
      font-size: 14px;
      font-weight: normal;
      height: 20px;
      letter-spacing: 0px;
      line-height: 20px;
      font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
    }
    .value {
      top: 66px;
      position: absolute;
      color: white;
      font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
      font-size: 14px;
      font-weight: 600;
      height: 20px;
      letter-spacing: 0px;
      line-height: 20px;
      white-space: nowrap
    }
    .next_beam {
      left: 0px;
    }
    .ttho {
      left: 173px;
    }
    .dth {
      left: 282px;
    }
  }
`;

function NextSatellitePanelContainerWrapper({ terminalDetails }: NextSatellitePanelContainerWrapperProps) {
  return (
    <StyledNextSatellitePanelContainerWrapper terminalDetails={terminalDetails}>
      <TerminalDetailsContext.Provider value={terminalDetails}>
        <NextSatellitePanelContainer />
      </TerminalDetailsContext.Provider>
    </StyledNextSatellitePanelContainerWrapper>
  );
}

export default requireFeatureFlag(NextSatellitePanelContainerWrapper, FEATURE_FLAGS.isNextSatellitePanelEnabled);
